import { isIOS } from "@tmsw/powerups.utils.is-ios";

const isSafariPortait = () => {
    const clientWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );
    const clientHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
    );
    const iOSPortait = clientHeight > clientWidth;
    return iOSPortait;
};

export const getOrientation = () => (window.screen.orientation || {}).type ||
    // @ts-ignore
    window.screen?.mozOrientation ||
    // @ts-ignore
    window.screen?.msOrientation ;

export const isInLandscape = () => {
    const orientation = getOrientation();
    return orientation === "landscape-primary" ||
        orientation === "landscape-secondary" ||
        window.matchMedia("(orientation: landscape)").matches;
};

export const isInPortrait = () => {
    const orientation = getOrientation();
    if(isIOS()) {
        return isSafariPortait();
    }
    return orientation === "portrait-primary" ||
    orientation === "portrait-secondary" ||
    window.matchMedia("(orientation: portrait)").matches;
};
